// extracted by mini-css-extract-plugin
module.exports = {"aiSearchSupportsContainer":"AISupports_aiSearchSupportsContainer__gfIsn"};